export const OEMCODE  = {
    IVECO: 'iveco',
    SSANGYONG: 'ssangyong',
    OPEL: 'opel',
    MITSUBISHI: 'mitsubishi',
    MELCO: 'melco',
    STELLANTIS: 'stellantis'
}
export const readOnlyOemCode: ReadonlyArray<string> = ['iveco', 'ssangyong', 'opel', 'mitsubishi', 'melco', 'stellantis'];